import React from "react";
import { Link, useLocation } from "react-router-dom";
import { IconX, IconMessage } from "@tabler/icons-react";
import logo from "../../assets/matrixcare-logo.png";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  isMobile: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose, isMobile }) => {
  const location = useLocation();
  const navigation = [{ name: "Chat Assistant", href: "/", icon: IconMessage }];

  if (isMobile) {
    return (
      <>
        <div
          className={`fixed inset-0 bg-gray-900/80 z-40 transition-opacity ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={onClose}
        />
        <div
          className={`fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="h-full bg-white shadow-xl">
            <div className="flex items-center justify-between px-6 py-4 border-b">
              <img className="h-12 w-auto" src={logo} alt="App Logo" />
              <button
                onClick={onClose}
                className="p-2 rounded-lg hover:bg-gray-50"
              >
                <IconX className="h-6 w-6 text-gray-600" />
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto p-4">
              <SidebarContent
                navigation={navigation}
                pathname={location.pathname}
              />
            </nav>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="hidden lg:fixed lg:inset-y-0 lg:z-40 lg:flex lg:w-64 lg:flex-col">
      <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
        <div className="flex h-16 shrink-0 items-center">
          <img className="h-12 w-auto" src={logo} alt="App Logo" />
        </div>
        <SidebarContent navigation={navigation} pathname={location.pathname} />
      </div>
    </div>
  );
};

const SidebarContent = ({
  navigation,
  pathname,
}: {
  navigation: Array<{ name: string; href: string; icon: any }>;
  pathname: string;
}) => {
  return (
    <ul className="space-y-1">
      {navigation.map((item) => {
        const Icon = item.icon;
        const isActive = pathname === item.href;
        return (
          <li key={item.name}>
            <Link
              to={item.href}
              className={`
                flex items-center gap-3 px-3 py-2 rounded-lg transition-colors
                ${isActive ? "bg-brand-primary/10 text-brand-primary font-semibold" : "text-gray-600 hover:bg-gray-100"}
              `}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="text-sm">{item.name}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default Sidebar;
